import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export const ModernIconButtonGroup = ({
  name,
  choices,
  selectedValue,
  onChange,
  iconSize = '1x',
}) => (
  <div role="group" className="icon-button-group">
    {choices.map(({ label, value, icon }) => (
      <button
        id={`${name}-button`}
        key={value}
        className={`foundry--button button--contained button--modern-icon ${
          selectedValue === value && 'selected'
        }`}
        type="button"
        aria-pressed={selectedValue === value}
        aria-label={label}
        onClick={e => {
          e.preventDefault()
          onChange(value)
        }}
      >
        <span className="button--label">
          <FontAwesomeIcon icon={icon} size={iconSize} />
        </span>
      </button>
    ))}
  </div>
)
